<template>
  <div class="tvControl notranslate">
    <div class="mode" :data-mode="mode">
      <button v-if="isControl" type="button" class="btn btnWhite btnController toCapitalize"
        :class="{active: mode === 'controller'}"
        @click="setMode('controller')">
        <i>&#9886;</i> {{locale.tvcontrol_remote_control}}
      </button>
      <button type="button" class="btn btnWhite toCapitalize"
        :class="{active: mode === 'chList'}"
        @click="setMode('chList')">
        <i>&#9776;</i> {{locale.tvcontrol_channel_list}}
      </button>
    </div>
    <!--
    <ChannelGenre
      v-if="genre.length > 0"
      :lang="lang"
      :locale="locale"
      :list="genre"
      @active="setGenre"
      @viewBookmark="setBookmarkOnly" />
       -->
    <div v-if="tvNames && tvNames.length > 0" class="tvNames">
      <span class="notranslate">{{locale.tv_select}}</span>
      <select class="input" v-model="tvIdx" @change="setTvIndex">
        <option v-for="t in tvNames"
          :key="t.index"
          :value="t.index">
          {{t.name[lang]}}
        </option>
      </select>
    </div>
    <div v-if="chList.length > 0" class="channelList">
      <ChannelList
        :lang="lang"
        :locale="locale"
        :list="channel"
        :isControl="isControl"
        :viewBookmark="viewBookmark"
        :tvIndex="tvIndex"
        @chBookmark="setBookmark"
        @toast="toastMsg" />
    </div>
    <div v-else class="noData">
      {{locale.tvcontrol_nodata}}
    </div>
    <Controller
      v-if="isControl && mode === 'controller'"
      :lang="lang"
      :locale="locale"
      :roomKey="roomKey"
      :tvIndex="tvIndex"
      @toast="toastMsg" />
    <button type="button" class="btnPower"
      v-else-if="isControl && mode === 'chList'"
      @click="remoteTv('power')"></button>
    <p v-if="toast" class="toastMsg">
      <span v-if="toast === 'notSupported'">{{locale.tvcontrol_notsupported_message}}</span>
      <span v-else>{{locale.tvcontrol_toast_message}}<br>{{locale.ask_front}}</span>
    </p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ChannelList from '@/components/TvControl/ChannelList.vue'
import ChannelGenre from '@/components/TvControl/ChannelGenre.vue'
import Controller from '@/components/TvControl/Controller.vue'

export default {
  name: 'TvControl',
  props: [
    'lang',
    'ln',
    'locale',
    'roomKey'
  ],
  components: {
    ChannelList,
    ChannelGenre,
    Controller
  },
  computed: {
    ...mapGetters({
      chList: 'tv/getChannelList',
      setting: 'tv/getSetting'
    }),
    isControl () {
      return this.setting.control
    },
    channel () {
      const filter = this.genre.filter(x => x.active).map(x => x.id)
      const bookmark = this.bookmark
      const isBookmarkOnly = this.viewBookmark
      // 전체리스트에 즐겨찾기 정보 추가 (즐겨찾기 채널은 로컬스토리지에 저장)
      const list = this.chList.map(x => {
        const isBookmark = bookmark.includes(x.id)
        return {
          ...x,
          bookmark: isBookmark
        }
      })
      // 즐겨찾기 채널만 보기 필터
      const setList = isBookmarkOnly ? list.filter(x => x.bookmark) : list
      // 장르로 채널 필터
      const setGenreList = filter.length > 0 ? setList.filter(x => filter.includes(x.genre)) : setList
      // 채널 소팅:: 채널번호
      const sortListByNo = setGenreList.sort(function (a, b) {
        // const noA = Number(onlyNo(a.no).replace('-', '.'))
        // const noB = Number(onlyNo(b.no).replace('-', '.'))
        const noA = Number(a.no.replace('-', '.'))
        const noB = Number(b.no.replace('-', '.'))
        return noA < noB ? -1 : noA > noB ? 1 : 0
      })
      /*
      function onlyNo (ch) {
        const hasWave = ch.includes('#')
        return hasWave ? ch.split('#')[1] : ch
      }
      */
      // 채널 소팅:: 언어
      const currentLang = this.ln
      const sortListByLang = sortListByNo.sort(function (a, b) {
        a.ln = (a.lang === currentLang) || (currentLang.includes(a.lang)) ? 2 : a.lang === 'en' ? 1 : 0 // zh: zh-CN or ch-TW
        b.ln = (b.lang === currentLang) || (currentLang.includes(b.lang)) ? 2 : b.lang === 'en' ? 1 : 0
        return a.ln > b.ln ? -1 : a.ln < b.ln ? 1 : 0
      })
      return sortListByLang
    },
    tvNames () {
      const setting = this.setting
      const names = setting.tvNames
      const tvCount = this.tvCount
      const tvNames = names ? names.map((x, i) => {
        return {
          ...x,
          index: i,
          ...tvCount && {
            hasTv: tvCount[i] === 1
          }
        }
      }).filter(x => x.hasTv) : null
      return names && names.length ? tvNames : null
    },
    tvIndex () {
      return this.tvIdx ? `${this.tvIdx}` : '0'
    }
  },
  created () {
    this.init()
  },
  mounted () {
    // nsj 예외처리:: 컨트롤러 디폴트
    const partner = this.$store.state.system.partner
    if (partner.name === 'CoreGuide') {
      this.mode = 'controller'
    }
  },
  data () {
    return {
      genre: [],
      bookmark: [],
      viewBookmark: false,
      toast: false,
      mode: 'chList', // chList || controller
      tvCount: null,
      tvIdx: 0
    }
  },
  methods: {
    track () {
      const site = this.$store.state.authentication.site
      const routerPath = this.$route.path
      const path = `${site}${routerPath}`
      this.$gtag.pageview({
        page_path: path,
        page_title: 'tv conrol'
      })
    },
    init () {
      this.getChList()
      this.getTvCount()
      this.track()
    },
    getTvCount () {
      const tvIndex = localStorage.getItem('tvIndex')
      if (tvIndex) {
        this.tvIdx = tvIndex
      }
      this.$store.dispatch('tv/getTvIndex').then((res) => {
        if (res) {
          this.tvCount = res.tvCount
          // this.tvCount = [1,0,1,0,0,0,0,0,0,0,]
          if (tvIndex && this.tvCount[tvIndex] !== 1) {
            localStorage.removeItem('tvIndex')
            this.tvIdx = '0'
          }
        }
      })
    },
    getChList () {
      this.$store.commit('loading', true)
      this.$store.dispatch('tv/getSetting')
      this.$store.dispatch('tv/getChannel').then((res) => {
        // 채널 장르 필터 초기세팅
        const genreList = res ? [...new Set(res.map(x => x.genre))] : []
        const localGenre = localStorage.getItem('activeChannelGenre')
        this.genre = genreList.map(x => {
          const isActive = localGenre !== null ? localGenre.includes(x) : true
          return {
            id: x,
            active: isActive
          }
        })
        // 채널 즐겨찾기 로컬스토리지 설정
        const localBookmark = localStorage.getItem('bookmarkChannel')
        this.bookmark = localBookmark !== null ? JSON.parse(localBookmark) : []
        this.$store.commit('loading', false)
      })
    },
    setGenre (id) {
      const genre = this.genre.find(x => x.id === id)
      genre.active = !genre.active
      function channelGenre (genre) {
        const activeList = genre.filter(x => x.active).map(x => x.id)
        return JSON.stringify(activeList)
      }
      localStorage.setItem('activeChannelGenre', channelGenre(this.genre))
    },
    setBookmark (id) {
      const bookmarkChannel = this.bookmark.includes(id) ? this.bookmark.filter(x => x !== id) : [...this.bookmark, id]
      this.bookmark = bookmarkChannel
      localStorage.setItem('bookmarkChannel', JSON.stringify(bookmarkChannel))
    },
    setBookmarkOnly (isBookmarkOnly) {
      this.viewBookmark = isBookmarkOnly
    },
    setMode (mode) {
      this.mode = mode
    },
    setTvIndex () {
      if (this.roomKey) {
        localStorage.setItem('tvIndex', this.tvIndex)
      }
    },
    toastMsg (message) {
      this.toast = message
      setTimeout(() => {
        this.toast = false
      }, 2000)
    },
    remoteTv (cmd) {
      const data = {
        cmd: cmd,
        tv: this.tvIndex,
        type: 'button'
      }
      this.$store.dispatch('tv/setTvControl', data).then((res) => {
        if (res.data && res.data.status === 403) {
          const message = res.data.message.includes('notSupported')
            ? 'notSupported'
            : 'fail'
          this.toastMsg('toast', message)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.tvControl {
  padding-top: 45px;
}
.notFound,
.noData {
  padding: 75px 30px 200px;
  text-align: center;
  font-size: 1.2em;
  &:before {
    content: "";
    display: block;
    height: 128px;
    margin-bottom: 15px;
    background: url('~@/assets/img/tvcontrol_nodata.png') 50% 50% / contain no-repeat;
  }
}
.btnMyChannel {
  margin: 5px 15px -10px;
  text-align: right;
  button {
    border-radius: 2px;
  }
}
.btnPower {
  position: fixed;
  bottom: 8px;
  right: 8px;
  width: 48px;
  height: 48px;
  border: 1px solid #1a1c1d;
  border-radius: 100%;
  background-color: #32323a;
  z-index: 1;
  &:before {
    content: "";
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    width: 20px;
    height: 20px;
    border-radius: 100%;
    border: 3px solid $color-white;
    transform: translate(-50%, -50%);
  }
  &:after {
    content: "";
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    width: 3px;
    height: 15px;
    margin-top: -8px;
    border-radius: 10px;
    border: 3px solid #32323a;
    background-color: $color-red;
    transform: translate(-50%, -50%);
  }
}
.mode {
  display: flex;
  position: fixed;
  top: 50px;
  left: 0;
  width: 100%;
  border-bottom: 1px solid $color-lgrey2;
  box-shadow: 0 0 10px rgba(0,0,0,0.1);
  z-index: 2;
  &[data-mode="controller"] {
    top: 0;
    z-index: 999;
  }
  .btn {
    flex: 1;
    padding: 0;
    height: 45px;
    border: none;
    & + .btn {
      border-left: 1px solid $color-lgrey2;
    }
  }
  .active {
    color: $color-white;
    background-color: $color-dark;
  }
}
.roomKey .mode {
  top: 90px;
  &[data-mode="controller"] {
    top: 0;
  }
}
.scrollDown .roomKey .mode {
  top: 50px;
  &[data-mode="controller"] {
    top: 0;
  }
}
.toastMsg {
  position: fixed;
  top: 50%;
  left: 50%;
  width: 80%;
  padding: 0.5em 1em;
  text-align: center;
  font-size: 0.85em;
  color: $color-white;
  border-radius: 4px;
  background-color: rgba($color-dark, 0.85);
  box-shadow: 0 0 5px rgba(0,0,0,0.3);
  transform: translate(-50%, -50%);
  z-index: 999;
}
@media screen and (min-width: 768px) {
  .mode {
    top: 0 !important;
    left: 80px;
    right: 0;
    width: auto;
    &[data-mode="controller"] {
      left: 0;
    }
  }
}
@media screen and (min-width: 800px) {
  .mode {
    left: 180px;
  }
}
@media screen and (min-width: 1024px) {
  .mode {
    left: 240px;
  }
  .channelList {
    padding-top: 15px;
    padding-left: 22px;
    padding-right: 22px;
  }
}
.tvNames {
  padding: 10px 8px;
  font-size: 0.85em;
  font-weight: normal;
  .input {
    width: auto;
    margin-left: 5px;
    min-height: 0;
    padding: 0.4em;
  }
  border-bottom: 1px solid $color-lgrey2;
  background-color: $color-white;
  box-shadow: 0 0 5px rgba(0,0,0,0.1);
}
</style>
